import { render, staticRenderFns } from "./FIBLogo.vue?vue&type=template&id=75f22932&scoped=true&"
import script from "./FIBLogo.vue?vue&type=script&lang=js&"
export * from "./FIBLogo.vue?vue&type=script&lang=js&"
import style0 from "./FIBLogo.vue?vue&type=style&index=0&id=75f22932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f22932",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
